export const doctorsAPI = [
    {
        id: 'ooxx1',
        name: 'Archie White',
        specialist: 'Dentist',
        appointment: 'Senior Doctor',
        experience: '10 years',
        img: 'assets/img/dentists/d-1.jpg'
    },
    {
        id: 'ooxx2',
        name: 'Dylan Taylor',
        specialist: 'Orthodontist',
        appointment: 'Senior Doctor',
        experience: '12 years',
        img: 'assets/img/dentists/d-2.jpg'
    },
    {
        id: 'ooxx3',
        name: 'Amy Clarke',
        specialist: 'Hygienist',
        appointment: 'Junior Doctor',
        experience: '5 years',
        img: 'assets/img/dentists/d-3.jpg'
    },
    {
        id: 'ooxx4',
        name: 'Jenna Berg',
        specialist: 'Dentist',
        appointment: 'Junior Doctor',
        experience: '5 years',
        img: 'assets/img/dentists/d-4.jpg'
    }
]